import { createEvent, createStore, sample } from 'effector'
import { debounce } from 'patronum'

import { $router } from '@/shared/lib/next'
import { persist } from '@/shared/lib/persist/local'

export * from './mute'
export * from './user'

export const chatToggled = createEvent<{ open: boolean }>()
export const chatFocused = createEvent()

export const $isChatOpen = createStore(false)
export const $isChatFocused = createStore(false)

export const $chatUnreadReplyCounter = createStore(0)

persist({
    store: $isChatOpen,
    key: 'chat-setting-open',
    pickup: $router,
})

sample({
    clock: chatToggled,
    fn: ({ open }) => open,
    target: $isChatOpen,
})

// open chat if it's focused
sample({
    clock: chatFocused,
    fn: () => true,
    target: [$isChatOpen, $isChatFocused],
})

// reset focused state after N seconds
sample({
    clock: debounce({ source: chatFocused, timeout: 2000 }),
    fn: () => false,
    target: $isChatFocused,
})
